import { jsx as _jsx } from "react/jsx-runtime";
import { Box, useMediaQuery, useTheme } from "@mui/material";
export const FormScrollable = ({ children }) => {
    const theme = useTheme();
    const isSm = useMediaQuery(theme.breakpoints.down("md"));
    return (_jsx(Box, { sx: {
            scrollbarWidth: "none",
            msOverflowStyle: "none",
            pb: 3.75,
            px: { xs: 2.5, md: 3 },
        }, children: children }));
};
